<mat-card>
  <app-card-header
    icono="assignment"
    [title]="title"
    [subtitle]="subtitle"
    [draggable]="!!dialogRef"
  ></app-card-header>

  <mat-divider></mat-divider>

  @if (!loading) {
    @if (form) {
      <form [formGroup]="form" (ngSubmit)="onSubmit()">
        <mat-card-content
          [class.cardContentDialog]="dialogRef"
          [class.cardContentFullscreen]="!dialogRef && !subtitle"
          [class.cardContentFullscreenSubtitle]="!dialogRef && subtitle"
          class="card-content-crear"
        >
          <section class="inputs-group">
            <!-- Nombre-->
            <mat-form-field style="width: 100%">
              <mat-label>Nombre</mat-label>
              <input matInput formControlName="nombre" />
            </mat-form-field>

            <!-- Costo -->
            <mat-form-field style="width: 100%">
              <mat-label>Costo</mat-label>
              <input matInput formControlName="costo" type="number" min="0" />
              <mat-icon matSuffix>attach_money</mat-icon>
            </mat-form-field>
          </section>

          <!-- Global -->
          @if (helper.esNivel0()) {
            <section class="inputs-group">
              <mat-checkbox color="primary" formControlName="global">
                Global
              </mat-checkbox>
            </section>
          }

          <!-- Ícono -->
          <section class="inputs-group">
            <app-upload-file
              [(url)]="urlIcono"
              textoBoton="Subir Ícono"
              (urlChange)="onUrlChange($event)"
            ></app-upload-file>
          </section>
        </mat-card-content>

        <mat-divider></mat-divider>

        <!-- Botones  -->
        <mat-card-actions class="actions-create">
          <app-button
            matType="mat-fab extended"
            color="neutral"
            (click)="this.helper.volver()"
            text="Cancelar"
            icon="close"
          ></app-button>
          <app-button
            matType="mat-fab extended"
            [disabled]="!this.form.valid"
            color="primary"
            text="Guardar"
            icon="save"
            type="submit"
          ></app-button>
        </mat-card-actions>
      </form>
    }
  } @else {
    <section class="inputs-group">
      <app-loading text="Cargando formulario..." [diameter]="60"></app-loading>
    </section>
  }
</mat-card>
